import { useCallback, useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { REWARDS_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import { getTextWidthInOneLine } from '../../../../utils/strings';
import ReportList from '../ReportList';
import ReportActionRow from '../ReportActionRow';

function ReportRewards({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              value !== null ? applyExcelFormats(value, REWARDS_COLUMNS[key]?.style?.numFmt) : null,
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  const getRowHeight = useCallback(
    index => {
      const resultsRows = formattedReport[index].result?.split('\n')?.length || 1;
      const resultsWidthInOneLine = getTextWidthInOneLine(formattedReport[index].result);

      const watchListRows = Object.values(formattedReport[index].watchList || {}).length;

      return Math.max(
        resultsRows * 18 + 18,
        resultsWidthInOneLine > 36 * 6 - 9
          ? Math.ceil(resultsWidthInOneLine / (36 * 6 - 9)) * 18 + 36
          : 0,
        watchListRows * 18 + 18,
        36,
      );
    },
    [formattedReport],
  );

  const formatCellConditionally = useCallback(() => ' bo-text-pre-line', []);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={REWARDS_COLUMNS}
        headerHeight={36}
        getRowHeight={getRowHeight}
        rowKey="id"
        formatCellConditionally={formatCellConditionally}
      />
    </>
  );
}

export default ReportRewards;
